import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import { getAddressDisplay } from '../../lib/helpers';

import Image from './Image';
import InfoItem from './InfoItem';

export const PracticeInformationDesktop = ({ practice, id, title, className }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (isMobile) return null;

  const headerPhoto = practice?.header_photo ? JSON.parse(practice.header_photo) : {};
  const imageFile = headerPhoto?.jpg || headerPhoto?.png;

  return (
    <div
      className={cn(
        'flex max-h-[198px] min-h-[148px] justify-between border-0 border-b border-solid border-b-neutral-200 bg-neutral-50',
        className
      )}>
      <div className="flex flex-col gap-3 px-6 pb-3 pt-6">
        <Typography variant="label" weight="semibold" className="uppercase">
          {title} {id ? `#${id}` : ''}
        </Typography>
        <Image
          className="h-[90px] w-auto max-w-[340px] object-contain"
          image={imageFile}
          practiceId={practice?.id}
        />
      </div>
      <div className="flex max-w-[50%] flex-1 flex-col items-end justify-center border-0 border-l border-solid border-l-neutral-200 p-6">
        {practice?.tax_id && <InfoItem label="Tax ID" value={practice?.tax_id} className="pb-2" />}
        <InfoItem value={practice?.displayName} />
        <InfoItem value={getAddressDisplay(practice?.address)} color="neutral-700" />
        <InfoItem value={practice?.phone} color="neutral-700" />
        <InfoItem value={practice?.email} color="neutral-700" />
        {practice?.website && <InfoItem value={practice?.website} color="neutral-700" />}
      </div>
    </div>
  );
};

export const PracticeInformationMobile = ({ practice, id, title, className }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (!isMobile) return null;
  const headerPhoto = practice?.header_photo ? JSON.parse(practice.header_photo) : {};
  const imageFile = headerPhoto?.jpg || headerPhoto?.png;

  return (
    <div
      className={cn(
        'flex h-fit min-h-[148px] flex-col justify-between border-0 border-b border-solid border-b-neutral-200 bg-neutral-50',
        className
      )}>
      <div className="flex flex-col gap-3 px-4 pb-2 pt-4 sm:px-2">
        <Typography variant="label" weight="semibold" className="uppercase">
          {title} {id ? `#${id}` : ''}
        </Typography>
        <Image
          className="h-[40px] w-auto max-w-[108px] object-cover"
          image={imageFile}
          practiceId={practice?.id}
        />
      </div>
      <div className="flex flex-1 flex-col justify-center border-0 border-l border-solid border-l-neutral-200 p-4 sm:px-2">
        {practice?.tax_id && <InfoItem label="Tax ID" value={practice?.tax_id} className="pb-2" />}
        <InfoItem value={practice?.displayName} />
        <InfoItem value={getAddressDisplay(practice?.address)} color="neutral-700" />
        <InfoItem value={practice?.phone} color="neutral-700" />
        <InfoItem value={practice?.email} color="neutral-700" />
        {practice?.website && <InfoItem value={practice?.website} color="neutral-700" />}
      </div>
    </div>
  );
};
